export const MAX_BULK_EDIT_SELECTION = 100

export const POSITIVE_INTEGER_COLUMN_KEYS = ['sorting', 'multipleSellingUnits', 'minimumOrderQuantity']

export const isPositiveInteger = value => {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue === '' || /^[1-9]\d*$/.test(normalizedValue)
}
